var exports = {
  "Qs": "ExternalLinkWarningModal.module__content___VkN5Wj",
  "zc": "ExternalLinkWarningModal.module__iconContainer___VkN5Wj",
  "kJ": "ExternalLinkWarningModal.module__iconCircle___VkN5Wj",
  "QW": "ExternalLinkWarningModal.module__warningIcon___VkN5Wj",
  "FS": "ExternalLinkWarningModal.module__textContainer___VkN5Wj",
  "DD": "ExternalLinkWarningModal.module__title___VkN5Wj",
  "h_": "ExternalLinkWarningModal.module__description___VkN5Wj",
  "VU": "ExternalLinkWarningModal.module__urlSection___VkN5Wj",
  "A7": "ExternalLinkWarningModal.module__urlLabel___VkN5Wj",
  "vQ": "ExternalLinkWarningModal.module__urlBox___VkN5Wj",
  "xG": "ExternalLinkWarningModal.module__urlText___VkN5Wj",
  "mH": "ExternalLinkWarningModal.module__checkboxLabel___VkN5Wj",
  "x6": "ExternalLinkWarningModal.module__button___VkN5Wj",
};

module.exports = exports;
